export enum ApiCustomHeader {
  AcceptLanguage = "Accept-Language",
  ApiVersion = "x-version",
  RecaptchaTokenV3 = "X-Recaptcha3-Response",
  RecaptchaTokenV2 = "X-Recaptcha2-Response",
  ClientId = "X-Client-Id",
}
